import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useUser } from "../utils/UserContext";
import PortfolioCard from "../components/PortfolioCard";
import CoinAllocation from "../components/CoinAllocation";



import {
  formatCurrency,
  getCurrencySymbol,
  getRate,
} from "../utils/currencyUtils";
import { toast } from "react-hot-toast";
import {
  faEye,
  faEyeSlash,
  faFileLines,
} from "@fortawesome/free-regular-svg-icons";

function Stock1() {
  const [see, setSee] = useState(true);
  const { user } = useUser();
  const [stock, setStock] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    fetch(`/stock_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const stockList = Object.values(data);
        const updatedData = stockList.map((stock, index) => ({
          id: index + 1,
          logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
          name: stock.name,
          type: "stock",
          symbol: stock.symbol,
          price: Number(stock.price.toFixed(2)),
        }));
        setStock(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };

  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => {
      isMounted = false;
    };
  }, [currencyCode]);

  const filteredStock = stock.filter((filteredAsset) =>
    Object.values(filteredAsset).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification
          isOpen={notificationbar}
          toggleNotification={toggleNotification}
        />
        <Sidebar
          title="Stock"
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          toggleSettingsBar={toggleSettingsBar}
          settingsBar={settingsBar}
        />
        <div className="col ps-md-2 mainBar">
          <Header
            title="Stock"
            icon={
              <FontAwesomeIcon icon={faWallet} style={{ fontSize: "16px" }} />
            }
            toggleSidebar={toggleSidebar}
            toggleNotification={toggleNotification}
            toggleSettingsBar={toggleSettingsBar}
          />
          <main>
            <div className="row">
                  <div className="col-md-12"> <PortfolioCard /></div>
                  <div className="col-md-12"><CoinAllocation /></div>          
              <div className="col-12">
                 
                <div className="mycard mt-2" style={{ minHeight: "85vh" }}>
                  {/* <div  className="balance-card d-flex align-items-center justify-content-between mb-4 p-3 rounded-4 shadow-sm"
                    style={{
                      background:
                        "linear-gradient(90deg, #18181b 0%, #23272f 100%)",
                      border: "1px solid #23272f",
                      color: "#fff",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <div className="balance-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                        style={{
                          background: "#2563eb33",
                          width: "40px",
                          height: "40px",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faWallet}
                          style={{ fontSize: "20px", color: "#fff" }}
                        />
                      </div>
                      <div>
                        <div className="fw-bold mb-0"
                          style={{ fontSize: "1.1rem", color: "#e5e7eb" }}
                        >
                          Total {user?.currency} Balance:
                        </div>
                        <div className="fw-bold"
                          style={{ fontSize: "1.3rem", color: "#fff" }}
                        >
                          {see && (
                            <span>
                              {getCurrencySymbol(user?.currency)}
                              {formatCurrency(user?.balance * rate)}
                            </span>
                          )}
                          <FontAwesomeIcon
                            icon={see ? faEye : faEyeSlash}
                            className="ms-2"
                            style={{
                              fontSize: "16px",
                              cursor: "pointer",
                              color: "#94a3b8",
                            }}
                            onClick={() => setSee(!see)}
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <h4 className="fw-bold text-center">All Stocks</h4>
                  <p className="text-center" style={{ fontSize: "14px" }}>
                    Full list of all stocks, ETFs & ADRs available on Bomboo.
                  </p>
                  <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                    <FontAwesomeIcon
                      className="me-2"
                      icon={faMagnifyingGlass}
                      style={{ fontSize: "16px" }}
                    />
                    <input
                      type="text"
                      placeholder="Search for stocks"
                      className="searchinput"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <div className="mt-2 row">
                    {filteredStock.map((stocklist) => {
                      return (
                        <>
                          <div className="col-lg-4">
                            <Link
                              to={`/stocklist?symbol=${encodeURIComponent(
                                stocklist.symbol
                              )}`}
                              className="d-flex align-items-center justify-content-between my-2"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              <div className="d-flex align-items">
                                <div
                                  className="overflow-hidden d-flex align-items-center justify-content-center rounded-circle"
                                  style={{ width: "25px", height: "25px" }}
                                >
                                  <img
                                    src={stocklist.logo}
                                    alt={stocklist.name}
                                    style={{ width: "100%" }}
                                  />
                                </div>
                                <div className="ms-2">
                                  <h6
                                    className="mb-0 fw-bold"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {stocklist.name}
                                  </h6>
                                  <p
                                    className="text-secondary mb-0"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {stocklist.symbol}
                                  </p>
                                </div>
                              </div>
                              <p
                                className="mb-0 fw-bold text-success"
                                style={{ fontSize: "13px" }}
                              >
                                {getCurrencySymbol(user?.currency)}
                                {formatCurrency(stocklist.price * rate)}
                              </p>
                            </Link>
                            <hr className="my-0" style={{ opacity: "0.05" }} />
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Stock1;
